import { createLightTheme } from 'baseui'

const LightTheme = createLightTheme({}, {})
export default LightTheme
